export default __webpack_public_path__ + "static/media/users.4a32de7b.svg";